import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { Asociacion, Ejercicio, EjerciciosService, ResponseAsociaciones, ResponseEjercicios } from '../../../../api';
import { ListadoComponent } from '../../listado/listado.component';
import { CommonModule } from '@angular/common';
import { BodyRequest, FunctionsAvailable, ItemType } from '../../formulario/request.model';
import { FormEvent, ItemEvent } from '../../item/item.model';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { Field } from '../../formulario/field.model';
import { FORM_BUTTONS } from '../../formulario/form-buttons.config';
import { FormButtonType } from '../../formulario/formButtonType.enum';
import { FormularioService } from '../../../services/formulario.service';
import { NavegacionService } from '../../../services/navegacion.service';
import { MigasService } from '../../../services/migas.service';
import { mensajeErrorCarga } from '../../../core/http-errors';
import { ErrorFichaComponent } from '../../error-ficha/error-ficha.component';
import { FormularioComponent } from '../../formulario/formulario.component';
import { EjercicioAsociadosComponent } from '../ejercicio-asociados/ejercicio-asociados.component';
import { AlertService } from '../../alert/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TabsNavDirective } from '../../ui/tabs-nav.directive';

export enum ViewModeEjercicio {
  ASOCIACIONES = 'asociaciones',
  ASOCIADOS = 'asociados'
}

@Component({
  selector: 'app-ejercicio',
  standalone: true,
  imports: [ListadoComponent, CommonModule, SpinnerComponent, FormularioComponent, ErrorFichaComponent, EjercicioAsociadosComponent, TabsNavDirective],
  templateUrl: './ejercicio.component.html',
  styleUrl: './ejercicio.component.scss'
})
export class EjercicioItemComponent {
  FunctionsAvailable = FunctionsAvailable;
  ViewModeEjercicio = ViewModeEjercicio;
  viewMode: ViewModeEjercicio = ViewModeEjercicio.ASOCIACIONES;

  @Input()
  item!: Ejercicio;

  ItemType = ItemType;
  
  @Input()
  parent?: any;

  @Output()
  openItem = new EventEmitter<ItemEvent | FormEvent>();

  @Output()
  back = new EventEmitter<string>();
  
  preUrl: string = '';
  
  ejercicioId: number = -1;
  asociaciones: Asociacion[] = [];

  loading: Boolean = true;
  error = '';

  showEdit = false;
  buttons = [
    FORM_BUTTONS[FormButtonType.Borrar],
    FORM_BUTTONS[FormButtonType.Cancelar],
  ]
  fields: Field[] = [];
  type!: ItemType;
  
  constructor(
    private ejerciciosService: EjerciciosService,
    private formularioService: FormularioService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private nav: NavegacionService,
    private migas: MigasService
  ) { }

  ngOnInit() {
    if(!Boolean(this.item)) {
      this.ejercicioId = Number(this.route.snapshot.paramMap.get('id'));
      this.preUrl = this.route.snapshot.url[0].path;
    }
    // La pestaña activa se conserva en la URL (?vista=asociados): al volver de una ficha o recargar reaparece la misma.
    if (this.route.snapshot.queryParamMap.get('vista') === ViewModeEjercicio.ASOCIADOS) this.viewMode = ViewModeEjercicio.ASOCIADOS;
    this.loadData();
  }

  cambiarVista(vista: ViewModeEjercicio) {
    if (this.viewMode === vista) return;
    this.viewMode = vista;
    // Los filtros de una pestaña no se arrastran a la otra: solo se conserva la pestaña.
    this.router.navigate([], { relativeTo: this.route, replaceUrl: true, queryParams: { vista: vista === ViewModeEjercicio.ASOCIADOS ? vista : null, q: null, asociacion: null, cargo: null, tipo: null, estado: null, page: null, size: null } });
  }

  loadData() {
    this.error = '';
    if (this.ejercicioId === -1 && Boolean(this.item) && Boolean(this.item.id)) {
      this.ejercicioId = this.item.id!;
    }
    if (this.ejercicioId > 0) {
      this.loading = true;
      let ejercicio = this.ejerciciosService.ejerciciosGetById(this.ejercicioId);
      let asociaciones = this.ejerciciosService.getAsociacionesByEjercicio(this.ejercicioId!)
      // Los asociados NO se descargan aquí (eran ~13.000): los pagina app-ejercicio-asociados (GET /ejercicios/{id}/asociados?paginado=true).
      forkJoin([ejercicio, asociaciones]).subscribe({
        next: ([ejercicio, asociaciones]: [ResponseEjercicios, ResponseAsociaciones]) => {
          if (ejercicio.status?.status !== 200 || !ejercicio.ejercicios?.[0]) {
            this.fallar('El ejercicio no existe.');
            return;
          }
          this.item = ejercicio.ejercicios![0];
          this.migas.etiqueta('ejercicio:' + this.ejercicioId, String(this.item.ejercicio));
          if(asociaciones.status?.status === 200) {
            this.asociaciones = asociaciones.asociaciones!;
          }
          this.loading = false;
        },
        error: (err: HttpErrorResponse) => this.fallar(mensajeErrorCarga(err, 'el ejercicio'))
      });
    } else {
      this.fallar('El ejercicio no existe.');
    }
  }

  private fallar(mensaje: string) {
    this.error = mensaje;
    this.loading = false;
    this.alertService.danger(mensaje, 5000);
  }

  volverAlListado() {
    this.nav.volverAlListado('/ejercicios');
  }

  goTo() {
  }

  goBack(event?: any) {
    if (this.back.observed) {
      this.back.emit(event);
    } else {
      this.nav.volver('/ejercicios');
    }
  }

  emitOpenItem(event: any, type: string, parent: BodyRequest) {
    this.openItem.emit({item: event, type: type as ItemType, parent: parent});
  }

  editItem() {
    this.loading = true;
    let {fields, buttons, titleForm, mode, type} = this.formularioService.loadFormConfig(FunctionsAvailable.ejerciciosPut, this.buttons, this.item, 'Editar', ItemType.EJERCICIOS);
    this.fields = fields;
    this.buttons = buttons;
    this.type = type;
    this.loading = false;
    this.showEdit = true;
    this.openItem.emit({item: this.item, type: ItemType.EJERCICIOS as ItemType, functionSelected: FunctionsAvailable.ejerciciosPut});
  }

}
